import * as d3 from "d3";
import tooltip from "d3-tip";
import { wrapText } from "../../../utils/helper";
import {
  getChartData,
  getNoDataFoundLabel
} from "../../../utils/graph_service";

function groupBarChartUtility(
  chartConfig,
  divId,
  onDrillDown,
  drillDownConfig,
  level,
  allowDrillDown
) {
  const chartNode = document.getElementById(divId);
  if (!chartConfig.data || !chartNode) return;
  if (chartNode !== null) {
    while (chartNode.firstChild) {
      chartNode.removeChild(chartNode.firstChild);
    }
  }

  /** Render bar chart for group bar chart */
  function renderBarChart(
    data,
    keys,
    colors,
    accessor,
    divId,
    yAxisLabel,
    onDrillDown,
    isDrillDown,
    type
  ) {
    const margin = { top: 20, right: 20, bottom: 30, left: 20 };
    let width = 400 - margin.left;
    let height = 300 - margin.top - margin.bottom;
    if (chartNode.offsetWidth > width) {
      width = chartNode.offsetWidth - margin.left;
      height =
        chartNode.offsetHeight > height ? chartNode.offsetHeight - 55 : height;
    }

    let groupKey = (groupKey = accessor);
    //let keys = stackedBarChartKeys ;
    const x0 = d3
      .scaleBand()
      .domain(data.map(d => d[groupKey]))
      .rangeRound([margin.left, width - margin.right])
      .paddingInner(0.1);

    const x1 = d3
      .scaleBand()
      .domain(keys)
      .rangeRound([0, x0.bandwidth()])
      .padding(0.05);

    // const max = d3.max(
    // 	data,
    // 	d => d3.max(keys, key => parseFloat(d[key])) //.toFixed(2)
    // );
    let min = d3.min(
      data,
      d => d3.min(keys, key => parseFloat(d[key])) //.toFixed(2)
    );

    if (min > 0) {
      min = 0;
    }
    const y = d3
      .scaleLinear()
      .domain([
        min,
        Math.abs(
          d3.max(
            data,
            d => d3.max(keys, key => parseFloat(d[key])) //.toFixed(2)
          )
        )
      ])
      .nice()
      .rangeRound([height - margin.bottom, margin.top]);

    const color = d3.scaleOrdinal().range(colors);

    const svg = d3
      .select("#" + divId)
      .append("svg")
      // .attr("width", width + margin.left + "px")
      // .attr("height", height + margin.top + margin.right + margin.bottom + "px")
      // .append("g")
      .attr("viewBox", [
        0,
        0,
        width + margin.right + margin.right,
        height + margin.top + margin.right + margin.bottom
      ])
      //.attr('viewBox','0 0 '+Math.min(width,height) +' '+Math.min(width,height) )
      .attr("preserveAspectRatio", "xMinYMin")
      .append("g")
      .attr(
        "transform",
        "translate(" + (margin.top + margin.left) + "," + 10 + ")"
      );
    //getYAxisLabel(yAxisLabel, svg, -15, 0 - height / 2);
    document.querySelectorAll(".tooltip" + divId).forEach(function(a) {
      a.remove();
    });

    const tip = tooltip()
      .attr("class", "d3-tip tooltip" + divId)
      .html(function(d) {
        return d.key +
          " : " +
          (chartConfig.widgetconfig || {}).isForPerformance ==
          true
          ? parseFloat(d.value)
              .toFixed(2)
              .toLocaleString()
          : parseInt(d.value).toLocaleString() +
              ((chartConfig.unit || "") == null ? "" : chartConfig.unit || ""); //count
      });
    svg.call(tip);
    svg
      .append("g")
      .selectAll("g")
      .data(data)
      .join("g")
      .attr("transform", d => `translate(${x0(d[groupKey])},0)`)
      .selectAll("rect")
      .data(function(d) {
        // console.log("my", d);
        return keys.map(key => ({
          key,
          value: d[key],
          accessor: d[groupKey],
          seriesItem: d.seriesItem
        }));
      })
      .join("rect")
      .attr("x", d => x1(d.key))
      .attr("y", d => {
        const x = y(0) - y(d.value);
        return y(0) - y(d.value) < 0
          ? y(d.value) - Math.abs(y(0) - y(d.value))
          : x == 0
          ? d.value > 0
            ? y(d.value) - 5
            : y(d.value)
          : y(d.value);
      })
      .attr("width", x1.bandwidth())
      .attr("height", d => {
        let v = Math.abs(y(0) - y(d.value));
        if (v == 0) {
          if (d.value > 0) v = 5;
        }
        return v;
      })
      .attr("fill", d => color(d.key) || colors[d.key])
      .attr("class", "rect-bar")
      .style("cursor", "pointer")
      .on("mouseover", tip.show)
      .on("mouseout", tip.hide)
      .on("click", function(d) {
        //alert(d.key + d[groupKey]);
        tip.hide(this);
        type = "Month";
        if ((chartConfig.widgetconfig || {}).isForPerformance == true) {
          level = drillDownConfig.currentLevel;
          type =
            (
              drillDownConfig.config.find(
                x => x.level == drillDownConfig.currentLevel
              ) || {}
            ).type == "YTD"
              ? "Month"
              : "Day";
        }
        // console.log(d);
        onDrillDown(true, d.key, type, d.accessor, level + 1, d.seriesItem);
      });

    let totalCount = 0;
    data.forEach(function(d) {
      d.total = d3.sum(keys, k => +parseFloat(d[k]).toFixed(2));
      totalCount += d.total;
      return d;
    });

    if (totalCount == 0) {
      getNoDataFoundLabel(
        chartConfig.startDate + " to " + chartConfig.endDate,
        svg,
        height / 2,
        width / 2
      );
    }
    if (divId == "MonthToDate" || divId == "YearToDate") {
      svg
        .append("g")
        .attr("class", "bottom-row")
        .attr("transform", `translate(0,${height - margin.bottom})`)
        .call(d3.axisBottom(x0).tickSizeOuter(0))
        .selectAll("text")
        .call(wrapText, x0.bandwidth())
        .style("text-anchor", "revert")
        .style("font-family", "roboto")
        .style("font-weight", "500")
        .style("font-size", "10px")
        .attr("transform", "rotate(0)");
    } else {
      svg.append("g").call(g =>
        g
          .attr("transform", `translate(0,${height - margin.bottom})`)
          .attr("class", "bottom-row")
          .call(d3.axisBottom(x0).tickSizeOuter(0))
          .selectAll(".tick text")
          .attr("transform", `rotate( ${data.length > 5 ? -45 : 0})`)
          .style("font-size", `${data.length > 10 ? 0.475 : 0.775})`)
          .html("")
          .append("tspan")
          .text(function(d) {
            return d;
          })
          .attr("x", `${data.length > 5 ? -10 : 0}`)
          .style("text-anchor", `${data.length > 5 ? "end" : "middle"}`)
          .call(g => g.select(".domain").remove())
      );
    }

    svg
      .append("g")
      .attr("transform", `translate(${margin.left},0)`)
      .attr("class", "y-axis")
      .style("color", "#000000")
      .style("font-family", "roboto")
      .style("font-weight", "500")
      .style("font-size", "10px")
      .call(d3.axisLeft(y).ticks(null, "s"))
      .call(g => g.select(".domain").style("color", "#252525"));

    if (drillDownConfig.currentLevel > 1) {
      let type = "Month";
      if ((chartConfig.widgetconfig || {}).isForPerformance == true) {
        level = drillDownConfig.currentLevel;
        type = "YTD";
        allowDrillDown = true;
      }
      svg
        .append("svg")
        .style("fill", "#07406d")
        .style("cursor", "pointer")
        .attr("y", -10)
        .attr("x", -10)
        .append("path")
        .attr(
          "d",
          "M22 3H7c-.69 0-1.23.35-1.59.88L.37 11.45c-.22.34-.22.77 0 1.11l5.04 7.56c.36.52.9.88 1.59.88h15c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-3.7 13.3c-.39.39-1.02.39-1.41 0L14 13.41l-2.89 2.89c-.39.39-1.02.39-1.41 0a.9959.9959 0 010-1.41L12.59 12 9.7 9.11a.9959.9959 0 010-1.41c.39-.39 1.02-.39 1.41 0L14 10.59l2.89-2.89c.39-.39 1.02-.39 1.41 0 .39.39.39 1.02 0 1.41L15.41 12l2.89 2.89c.38.38.38 1.02 0 1.41z"
        )
        .on("click", function() {
          //alert("jj");
          onDrillDown(false, drillDownConfig.key, type, "", level);
        });
    }

    svg
      .append("text")
      .attr("transform", "rotate(-90)")
      .attr("y", -(margin.left + 10))
      .attr("x", 0 - height / 2)
      .attr("dy", "1em")
      .style("text-anchor", "middle")
      .style("font-family", "Roboto")
      .style("font-size", "10px")
      .style("font-weight", "500")
      .style("fill", "#000000")
      .text(yAxisLabel || "count");

    let legendLine = 10;
    let currentX = 0;
    const legend = svg
      .append("g")
      .attr("class", "legend-container")
      .attr("width", width)
      .attr("class", "bottom-row")
      .attr(
        "transform",
        "translate(" +
          20 +
          ", " +
          (height - margin.bottom + margin.left + 20) +
          ")"
      );
    legend
      .selectAll("g")
      .data(keys)
      .enter()
      .append("g")
      .each(function(d, i) {
        const g = d3.select(this);
        let y = legendLine;
        const rect = g
          .append("rect")
          .attr("y", y)
          .attr("x", currentX)
          .attr("width", 10)
          .attr("height", 10)
          .attr("class", d.replace(/[^a-zA-Z0-9]/g, "") + " legend")
          .style("fill", color(i));
        const size = rect.node().getBBox();
        currentX += size.width + 10;
        if (currentX > width) {
          currentX = 0;
          legendLine += 20;
          y = legendLine;
          rect.attr("x", currentX).attr("y", y);
          currentX += size.width + 10;
        }
        const recText = g
          .append("text")
          .attr("y", y + 10)
          .attr("x", currentX)
          .attr("height", 30)
          .attr("width", 170)
          .attr("class", d.replace(/[^a-zA-Z0-9]/g, "") + " legend")
          .style("fill", color(i))
          .style("font-family", "roboto")
          .style("font-weight", "500")
          .style("font-size", "12px")
          .text(d);

        const recTextSize = recText.node().getBBox();
        currentX += recTextSize.width + 20;
        if (currentX > width) {
          currentX = 0;
          legendLine += 20;
          y = legendLine;
          rect.attr("x", currentX).attr("y", y);
          currentX += size.width + 10;
          recText.attr("x", currentX).attr("y", y + 10);
          currentX += recTextSize.width + 20;
        }
      });
  }

  RenderChart();

  /** Render group bar chart */
  function RenderChart() {
    // console.log("here", drillDownConfig.isDrillDown, drillDownConfig);
    const drillConfigData = drillDownConfig.config.find(
      x => x.level == level + 1
    );
    if (drillDownConfig.isDrillDown && allowDrillDown == true) {
      let config = {};
      if ((chartConfig.widgetconfig || {}).isForPerformance != true) {
        let resData = {};

        const drillDownColumnsConfig = { ...chartConfig.configuration };
        const filters = [];
        if (chartConfig.configuration.isRepeated == true) {
          filters.push({
            key: chartConfig.configuration.autoGenerate.key,
            values: [drillDownConfig.config.find(x => x.level == level + 1).key]
          });
          drillDownColumnsConfig.autoGenerate.filters = filters;
        } else {
          drillDownColumnsConfig.columns = [
            chartConfig.configuration.columns.find(
              x =>
                x.name ==
                [drillDownConfig.config.find(b => b.level == level + 1).key]
            )
          ];
        }

        resData = getChartData(
          chartConfig.rawData,
          drillDownColumnsConfig,
          drillConfigData.seriesItem.start,
          drillConfigData.seriesItem.end,
          drillConfigData.type
        );

        config = {
          startDate: chartConfig.startDate,
          endDate: chartConfig.endDate,
          configuration: drillDownColumnsConfig,
          rawData: chartConfig.rawData,
          data: resData.data,
          yAxisLabel: chartConfig.yAxisLabel,
          type: "GroupBarChart",
          keys: resData.barKeys,
          colors: resData.barColors,
          accessor: resData.chartAccessor.mainAccessor
        };
        if (drillDownConfig.currentLevel == level + 1) {
          drillDownConfig.isDrillDown = false;
        }
        groupBarChartUtility(
          config,
          divId,
          onDrillDown,
          drillDownConfig,
          level + 1,
          allowDrillDown
        );
      } else {
        config = drillConfigData.performanceConfig;
        renderBarChart(
          config.data,
          config.keys,
          config.colors,
          config.accessor,
          divId,
          config.yAxisLabel,
          onDrillDown,
          drillDownConfig.isDrillDown,
          (drillConfigData || {}).type
        );
      }
    } else {
      renderBarChart(
        chartConfig.data,
        chartConfig.keys,
        chartConfig.colors,
        chartConfig.accessor,
        divId,
        chartConfig.yAxisLabel,
        onDrillDown,
        drillDownConfig.isDrillDown,
        (drillConfigData || {}).type
      );
    }
  }
}

export { groupBarChartUtility };
